
// import loader from '../../assets/img/loader.svg';
const TestLoader = () => {
    return(
        // <div style={{
        //     display: 'flex',
        //     justifyContent: 'center',
        //     alignItems: 'center',
        //     height: '100%',
        //     width: '100%'
        // }}>
        //     <img src={loader}  alt="Loader" />
        // </div>
        <div id="global-loader" className='center'>
            {/* <img src={loader} className="loader-img" alt="Loader"/> */}
           <div className="spinner-border text-warning" role="status">
  <span className="visually-hidden">Loading...</span>
</div>
        </div>
    );
};

export default TestLoader;
